// Набор линейных иконок 24×24 (stroke = currentColor). Имя иконки — строка, её же пишут в NavItem.icon.

import type { ReactNode, SVGProps } from 'react'

const dot = (cx: number, cy: number) => (
  <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={1.4} fill="currentColor" stroke="none" />
)

const ICONS = {
  today: <path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />,
  workout: <path d="M6.5 7v10M3.5 9.5v5M17.5 7v10M20.5 9.5v5M6.5 12h11" />,
  plan: (
    <>
      <rect x={4} y={5.5} width={16} height={15} rx={2} />
      <path d="M4 10h16M8.5 3v4M15.5 3v4" />
    </>
  ),
  health: (
    <path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7a4.3 4.3 0 0 1 7.5 2.8C19.5 15.4 12 20 12 20z" />
  ),
  more: <>{[dot(5.5, 12), dot(12, 12), dot(18.5, 12)]}</>,
  settings: (
    <>
      <path d="M4 7h9M17 7h3M4 12h3M11 12h9M4 17h11M19 17h1" />
      <circle cx={15} cy={7} r={2} />
      <circle cx={9} cy={12} r={2} />
      <circle cx={17} cy={17} r={2} />
    </>
  ),
  shield: <path d="M12 3 19.5 6v5.6c0 4.4-3.2 8.2-7.5 9.4-4.3-1.2-7.5-5-7.5-9.4V6z" />,
  lock: (
    <>
      <rect x={5} y={10.5} width={14} height={10} rx={2} />
      <path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3M12 14.5v2" />
    </>
  ),
  fingerprint: (
    <path d="M6.2 6.6A8 8 0 0 1 20 12v1M4 12a8 8 0 0 1 .5-2.8M8.5 20.5c-1-1.6-1.5-3.5-1.5-5.5v-3a5 5 0 0 1 10 0v2M12 12v3c0 2.6.8 4.6 2 6M16.8 17.5c-.2 1.1-.1 2.2.2 3M19.7 16.5c0 .9-.1 1.8-.3 2.6M12 3.5c-1.1 0-2.2.2-3.2.7M9.5 16c.1 1.8.6 3.5 1.5 5" />
  ),
  chart: <path d="M4 4v16h16M8 15l3.5-4.5 3 2.5L19 7" />,
  list: (
    <>
      <path d="M9 6.5h11M9 12h11M9 17.5h11" />
      {[dot(4.75, 6.5), dot(4.75, 12), dot(4.75, 17.5)]}
    </>
  ),
  history: <path d="M3.5 12a8.5 8.5 0 1 0 2.5-6M3.5 4v4.5H8M12 8v4.2l3 1.8" />,
  ai: <path d="M12 3.5 13.9 9l5.6 1.9-5.6 1.9L12 18.5l-1.9-5.7-5.6-1.9L10.1 9zM18.5 3v3M17 4.5h3" />,
  activity: <path d="M3 12h4l2.5-6.5 5 13L17 12h4" />,
  target: (
    <>
      <circle cx={12} cy={12} r={8.5} />
      <circle cx={12} cy={12} r={4.5} />
      {dot(12, 12)}
    </>
  ),
  character: (
    <>
      <circle cx={12} cy={5.5} r={2.5} />
      <path d="M12 8.5v6.5M6.5 10.5l5.5 1.5 5.5-1.5M9 21l3-6 3 6" />
      <path d="M19 3.5v3M17.5 5h3" />
    </>
  ),
  user: (
    <>
      <circle cx={12} cy={8} r={4} />
      <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
    </>
  ),
  key: (
    <>
      <circle cx={8} cy={15} r={4} />
      <path d="m11 12 8.5-8.5M16.5 6.5l2.5 2.5" />
    </>
  ),
  logout: <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 16l-4-4 4-4M6 12h10" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  'chevron-right': <path d="m9 6 6 6-6 6" />,
  'chevron-left': <path d="m15 6-6 6 6 6" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'arrow-up': <path d="M12 19V5M6 11l6-6 6 6" />,
  filter: <path d="M4 5h16l-6 7.5V19l-4 1.5v-8z" />,
  moon: <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />,
  dumbbell: <path d="M6.5 7v10M3.5 9.5v5M17.5 7v10M20.5 9.5v5M6.5 12h11" />,
  journal: (
    <>
      <path d="M6 3.5h11a1.5 1.5 0 0 1 1.5 1.5v15H7a2 2 0 0 1-2-2V4.5a1 1 0 0 1 1-1z" />
      <path d="M5 18a2 2 0 0 1 2-2h11.5M9 8h6M9 11.5h4" />
    </>
  ),
  'arrow-down': <path d="M12 5v14M6 13l6 6 6-6" />,
  refresh: <path d="M20 11a8 8 0 1 0-2.3 5.7M20 4.5V11h-6.5" />,
  'wifi-off': (
    <path d="m3 3 18 18M8.5 16a5 5 0 0 1 7 0M5 12.3a10 10 0 0 1 4.6-2.5M14.6 9.9A10 10 0 0 1 19 12.3M2 8.8a15 15 0 0 1 4.3-2.6M12 19.5h.01" />
  ),
  alert: <path d="M12 4 21 19.5H3zM12 10v4.5M12 17h.01" />,
  info: (
    <>
      <circle cx={12} cy={12} r={8.5} />
      <path d="M12 11v5M12 8h.01" />
    </>
  ),
  exclaim: (
    <>
      <circle cx={12} cy={12} r={8.5} />
      <path d="M12 7.5v5.5M12 16.5h.01" />
    </>
  ),
  copy: (
    <>
      <rect x={9} y={9} width={11} height={11} rx={2} />
      <path d="M5.5 15H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v.5" />
    </>
  ),
  download: <path d="M12 4v11M7 10.5l5 5 5-5M5 20h14" />,
  play: <path d="M7.5 5v14l11-7z" />,
  stop: <rect x={6.5} y={6.5} width={11} height={11} rx={1.5} />,
  pause: (
    <>
      <rect x={6.5} y={5} width={3.5} height={14} rx={1} />
      <rect x={14} y={5} width={3.5} height={14} rx={1} />
    </>
  ),
  swap: <path d="M4 8h15M15 4l4 4-4 4M20 16H5M9 12l-4 4 4 4" />,
} satisfies Record<string, ReactNode>

export type IconName = keyof typeof ICONS

type IconProps = Omit<SVGProps<SVGSVGElement>, 'name'> & {
  name: IconName
  size?: number
  /** Подпись для экранного диктора; без неё иконка декоративная. */
  title?: string
}

export function Icon({ name, size = 20, title, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {ICONS[name]}
    </svg>
  )
}
